export default {
	data() {
		return {
			// 实名认证
			isCertification: false,
		}
	},
	created() {
		this.getUserIsCertification();
	},
	methods: {
		// 判断用户是否认证
		getUserIsCertification() {
			Ajax.get('/api/usercenter/getPrivilegeNew', {
				region: this.$route.query.region
			})
			.then((res) => {
				// 0 未认证 1 个人认证通过 2 企业认证通过 3 个人和企业认证都通过
				if ([1, 2, 3].indexOf(res.data.result) >= 0) {
					this.isCertification = true;
				} else {
					this.isCertification = false;
				}
			})
		},
	}
}




// WEBPACK FOOTER //
// ./src/mixins/ifCertification.js